module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_15",
    attrs: {
      "id": "filepos12295"
    }
  }, [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "image",
      "src": "images/00002.jpg"
    }
  })])]), _c('div', {
    staticClass: "calibre_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('span', [_c('span', {
    staticClass: "calibre11"
  }, [_vm._v("W")])]), _vm._v("hen I first picked up this book, the title informed me that “nothing I see means anything.” That obviously included the book. Why, then, read it if it had no meaning? But like so many of the penetrating insights that David Parrish has woven into these pages, I discovered that it is necessary to consider this one as thoughtfully as he presents it.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("There is a profound difference between saying that no "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thing")]), _vm._v(" has meaning and that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seeing")]), _vm._v(" has no meaning. As is shown through Dr. Parrish’s brilliant examination of the phenomenon of projection, the way we see the things—the people, the circumstances—around us, holds the key to all meaning. Our take on the world and the significance we assign to everything from casual conversations to catastrophic events, determines whether we live a life smothered in illusions or a life of expanding freedom.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("In this book Dr. Parrish takes us on a walk. The flagstones we tread are concepts, each seemingly unique and separate. Yet because we are walking with a teacher who sees not only the path but its destination, we begin to notice that each concept leads gently and logically to the next. Subjects such as quantum physics, mysticism, cognitive psychology, and existential philosophy are interspersed with fascinating discussions of the effects of humor and the dynamics of loving relationships. The result is that we discover that we already know more than we believed we did. We simply had not noticed the connections between the ideas already within our mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("While introducing us to what some may think of as exotic and daunting thought systems, Dr. Parrish opens our eyes to the truth that all knowledge is already ours, although still locked, perhaps, beneath layers of unconsciousness. We further discover that there are multiple ways this knowledge can be drawn on and utilized now, today, in highly transformative ways. The chaotic landscape of our lives, this perplexing and often cruel world we seem hopelessly trapped in, can be transmuted into a comfortable and softly embracing Home. In short, projection can be put to Divine use.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("By way of example of how Dr. Parrish takes seemingly separate concepts and weaves them into a usable whole, consider the following six:")])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       1.  Nothing I see means anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       2.  Everything I see is a projection.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       3.  My body’s eyes are used to see what I outwardly project as separate from me.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       4.  Within the Divine nothing is seen because everything is experienced as One in the eternal present. Since nothing is separate, eyes are not needed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       5.  It is therefore what is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" seen that embraces us all in love, in happiness, and in an unalterable Truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("       6.  Once acknowledged, this Truth is reflected in our projections.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("Connected in this way, these concepts lead us to an ancient and familiar conclusion: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I do not have to figure anything out by myself. I can safely resign as my own teacher, lean instead on the sustaining Infinite, and put all things in God’s hands.")]), _vm._v(" This is a teaching contained in all the great scriptures and mystical writings as well as in problem-specific approaches such as the twelve steps of Alcoholic Anonymous, and it has unlimited application.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("David Parrish’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nothing I See Means Anything,")]), _vm._v(" which may at first appear to be a fear-provoking inquiry, turns out to be a book that releases us from fear, frees us to trust our destiny, and makes accessible a familiar Voice within, a Presence that seeks only to bless us.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_21"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("—Hugh Prather")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b727e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_005.vue
// module id = 75
// module chunks = 0